import React from "react"

import Layout from "../../components/Layout"
import SEO from "../../components/SEO"


const News = () => (
  <Layout>
    <SEO title="NEWS" keywords={[]}/>
  </Layout>
);

export default News